import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import Paper from '@mui/material/Paper'
import { Link as RouterLink } from 'react-router-dom'
import { DayEntryShell } from './entry/DayEntryShell'
import { DrawingsTab } from './report/DrawingsTab'

/**
 * Direct route to recording drawings received at site.
 *
 * <p>Receiving a drawing updates the project register: a new revision of a drawing
 * already listed supersedes the old one and clears it off the pending list, rather than
 * creating a second entry for the same drawing number.</p>
 */
export function DrawingEntryPage() {
  return (
    <DayEntryShell
      title="Drawing received"
      subtitle="Record drawings handed over at site, from the architect, structural engineer, MEP or kitchen consultant."
    >
      {(report, editable) => (
        <>
          <Alert severity="info" sx={{ mb: 2 }}>
            Recording a drawing here updates the project register and, if it was being
            chased, takes it off the{' '}
            <Link component={RouterLink} to="/drawings/pending">pending drawings</Link> list.
          </Alert>

          <Paper variant="outlined" sx={{ p: 2 }}>
            <DrawingsTab reportId={report.id} editable={editable} />
          </Paper>

          <Box sx={{ height: 24 }} />
        </>
      )}
    </DayEntryShell>
  )
}
